document.addEventListener('DOMContentLoaded', function() {
    // accordion items change image
    document.querySelectorAll('.accordion-item').forEach(function(item) {
        item.addEventListener('click', function() {
            const count = this.getAttribute('data-count');
            let i = 1;
            while (document.getElementById('mapImg_' + i)) {
                if (i != count) {
                    document.getElementById('mapImg_' + i).classList.add('d-none');
                    const additional = document.getElementById('mapImgAdditional_' + i);
                    if (additional) additional.classList.add('d-none');
                } else {
                    document.getElementById('mapImg_' + i).classList.remove('d-none');
                    const additional = document.getElementById('mapImgAdditional_' + i);
                    if (additional) additional.classList.remove('d-none');
                }
                i++;
            }
        });
    });
});

$(window).on('load', function() {
    // countup logic
    document.querySelectorAll('.countupValue[data-endval]').forEach(function(el) {
        const rawAttr = el.getAttribute('data-endval').replace(',', '.');
        const endVal = parseFloat(rawAttr) || 0;
        const decimalPlaces = (rawAttr.split('.')[1] || '').length;
        const cu = new window.countUp.CountUp(el, endVal, { enableScrollSpy: true, duration: 5, useGrouping: true, separator: '.', decimal: ',', decimalPlaces: decimalPlaces });
        cu.start();
    });

});
